@if (isVisible) {
  <div
    class="custom-loader-backdrop"
    animate.enter="fade-in"
    animate.leave="fade-out"
    role="presentation"
    aria-hidden="false"
    >
    <div
      class="custom-loader-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="loader-message"
      >
      <div class="loading-wrapper" aria-hidden="true">
        <!-- Gift card and spinner created via ::before and ::after in CSS -->
      </div>
      <div
        id="loader-message"
        class="loading-message"
        role="status"
        aria-live="polite"
        >
        {{ message }}
      </div>
    </div>
  </div>
}
